import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

import { Arrow } from './Arrow';

const SlideBox = styled.div<{ backgroundImage: string | undefined }>`
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: ${({ backgroundImage }) => backgroundImage && `url(${backgroundImage})`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${tokens.spacer.x2} 0 ${tokens.spacer.x5};
  border-radius: ${tokens.radius.l};
  ${tokens.transition('background-image', 600)};
`;

interface SlideProps {
  imageUrl?: string;
  onChange: (direction: 'left' | 'right') => void;
  isFirstElement: boolean;
  isLastElement: boolean;
}

export const Slide = ({
  imageUrl,
  onChange,
  isFirstElement,
  isLastElement,
}: SlideProps): JSX.Element => {
  return (
    <SlideBox backgroundImage={imageUrl}>
      <Arrow key={0} onClick={() => onChange('left')} isDisabled={isFirstElement} />
      <Arrow
        key={1}
        direction="right"
        onClick={() => onChange('right')}
        isDisabled={isLastElement}
      />
    </SlideBox>
  );
};
